import React from 'react';
import { connect } from 'react-redux';

import { updateGlove } from '../../actions/creators';
import syncPreview from '../higher-order/SyncPreview';
import CustomPythonButtons from '../CustomPythonButtons';

const FingerHood = ({
  customPythons,
  currentCustomPython,
  onCustomPythonClick,
}) => (
  <div className="step-item-view-wrap pull-right">
    <CustomPythonButtons
      title="FINGER HOOD COLOR"
      className="finger-hood-color-wrap"
      images={customPythons}
      currentCustomImage={currentCustomPython}
      onClick={onCustomPythonClick}
    />
  </div>
);

const mapStateToProps = (state) => {
  const { fingerHoodPython } = state.glove;

  return {
    customPythons: state.builder.leatherColors[state.glove.leatherGrade.id],
    currentCustomPython: fingerHoodPython,
  };
};

const mapDispatchToProps = dispatch => ({
  onCustomPythonClick: python => dispatch(updateGlove({ fingerHoodPython: python })),
});

export default syncPreview(connect(
  mapStateToProps,
  mapDispatchToProps,
)(FingerHood), 'fingerSide');
